//apiClient.js

import { API_BASE } from './config';
import Swal from 'sweetalert2';

export const customFetch = async (endpoint, options = {}) => {
  const token = sessionStorage.getItem('token');
  
  // Pehle sirf Authorization aur custom headers set karenge
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  // 🔥 SENIOR DEV FIX: Smart Content-Type Handling
  if (!(options.body instanceof FormData)) {
    // Agar body FormData nahi hai, aur pehle se koi Content-Type nahi diya, toh JSON set karo
    if (!headers['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }
  } else {
    // Agar body FormData hai, aur galti se Content-Type aa gaya hai, toh usko delete kar do
    // Isse browser khud "multipart/form-data; boundary=..." set kar payega
    delete headers['Content-Type'];
  }

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
  });

  // Global 401 (Session Expired) Check
  if (response.status === 401) {
    sessionStorage.clear();
    
    // Professional SweetAlert Popup
    await Swal.fire({
      icon: 'warning',
      title: 'Session Expired',
      text: 'Your session has expired or logged in from another device. Please log in again.',
      confirmButtonColor: '#0088cc',
      allowOutsideClick: false 
    });

    window.location.href = "/"; 
    return Promise.reject(new Error("Session Expired")); 
  }

  return response;
};